import React, { useEffect, useState } from "react";
import { hasInvoiceEdits } from "../../../assets/reusableComponents/invoiceEdits";
import "../../../assets/reusableComponents/InvoiceEditHighlight.scss";

// Import CSS
import "./InvoicesPendingTable.scss";
import PaymentModal from "../../PaymentModal";

//import icons
import { FaRegCreditCard } from "react-icons/fa6";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { listInvoicesUnpaid } from "../../../../redux/slices/sliceActions";

const InvoicePendingTable = ({ selectedApartmentId }) => {
  // redux methods
  const { unpaidinvoices } = useSelector((state) => state.landlordslice);

  useEffect(() => {
    console.log("here are the unpaid invoices", unpaidinvoices);
  }, [unpaidinvoices]);

  const formatApiInvoices = (apiInvoices) => {
    return apiInvoices.map((invoice, index) => {
      // Create due date from month and year (set to 1st of the month)
      const dueDate = new Date(invoice?.year, invoice?.month - 1, 1);
      const formattedDueDate = dueDate.toISOString().split("T")[0];

      return {
        invoice_id:
          invoice?._id?.substring(invoice?._id.length - 6) ||
          String(index + 1).padStart(3, "0"),
        house_id: invoice?.house?._id,
        house_no: invoice?.house?.house_no,
        payment_status:
          invoice?.status === "pending" ? "unpaid" : invoice?.status,
        due_date: formattedDueDate,
        rent_invoice: invoice?.rent || 0,
        water_invoice: invoice?.waters || 0,
        garbage_charge: invoice?.garbage || 0,
        service_charge: invoice?.service_charge || 0,
        late_fee: invoice?.late_fee || 0,
        arrears: invoice?.arrears || 0,
        unpaid_deposit: invoice?.unpaid_deposit || 0,
        isEdited: invoice?.isEdited,
      };
    });
  };

  useEffect(() => {
    if (unpaidinvoices && unpaidinvoices.length > 0) {
      const formattedInvoices = formatApiInvoices(unpaidinvoices);
      setInvoicesReceived(formattedInvoices);
    }
  }, [unpaidinvoices]);

  const [invoicesReceived, setInvoicesReceived] = useState([]);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    if (invoicesReceived.length > 0) {
      setInvoices(transformInvoices(invoicesReceived));
      console.log("Invoices:", invoices);
    }
  }, [invoicesReceived]);

  const [expandedInvoiceId, setExpandedInvoiceId] = useState(null);
  const [visibleInvoicesCount, setVisibleInvoicesCount] = useState(3); // Initially show 3 invoices

  const toggleExpand = (invoiceId) => {
    setExpandedInvoiceId(expandedInvoiceId === invoiceId ? null : invoiceId);
  };

  const showMoreInvoices = () => {
    setVisibleInvoicesCount((prevCount) => prevCount + 3);
  };

  const hideAllInvoices = () => {
    setVisibleInvoicesCount(3);
  };

  //modal
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
  };

  const [defaultValues, setDefaultValues] = useState({});
  useEffect(() => {
    //check if default values are set
    if (Object.keys(defaultValues).length > 0) {
      console.log("Default values:", defaultValues);
      setIsOpen(true); // Open the modal
    }
  }, [defaultValues]);

  const handlePayment = (invoiceId) => {
    // Handle the payment logic here
    setDefaultValues({}); // Clear the default values
    //function to find the invoice
    const invoice = invoices.find((invoice) => invoice?.id === invoiceId);
    console.log("found invoice", invoice);
    //set the default values
    setDefaultValues({
      rent: invoice?.rent?.toString() || "0",
      water: invoice?.water?.toString() || "0",
      arrears: invoice?.arrears?.toString() || "0",
      serviceCharge: invoice?.serviceCharge?.toString() || "0",
      unpaidDeposit: invoice?.unpaidDeposit?.toString() || "0",
      garbage: invoice?.garbage?.toString() || 0,
      paymentMethod: "M-Pesa",
      house_id: invoice?.house_id,
      house_no: invoice?.house_no,
    });
    console.log(`Payment for invoice ${invoiceId}`);
  };
  return (
    <>
      {invoices.length === 0 ? (
        <>No invoices yet</>
      ) : (
        <div className="invoices-pending-container">
          <table className="invoice-pending-table">
            <thead>
              <tr>
                <th>House Number</th>
                <th>Rent</th>
                <th>Water</th>
                <th>Garbage</th>
                <th>Service Fee</th>
                <th>Arrears</th>
                <th>Unpaid Deposit</th>
                <th>Late Fee</th>
                <th>Total</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {invoices.slice(0, visibleInvoicesCount).map((invoice) => (
                <React.Fragment key={invoice?.id}>
                  <tr
                    onClick={() => toggleExpand(invoice?.id)}
                    className={`table-row ${hasInvoiceEdits(invoice) ? "invoice-row-edited" : ""}`}
                    title={hasInvoiceEdits(invoice) ? "Manually changed" : undefined}
                  >
                    <td>{invoice?.house_no}</td>
                    <td>{invoice?.rent}</td>
                    <td>{invoice?.water}</td>
                    <td>{invoice?.garbage}</td>
                    <td>{invoice?.serviceCharge}</td>
                    <td>{invoice?.arrears}</td>
                    <td>{invoice?.unpaidDeposit}</td>
                    <td>{invoice?.lateFee}</td>
                    <td>{invoice?.totalPayable}</td>
                    <td>{invoice?.status}</td>
                    <td>
                      <button onClick={() => handlePayment(invoice?.id)}>
                      <FaRegCreditCard size={20} className="payment-icon" />
                      </button>
                    </td>
                  </tr>
                  {/* {expandedInvoiceId === invoice?.id && (
                    <tr>
                      <td colSpan="4">
                        <div className="expanded-space">
                          <div>
                            <div className="title">Invoice details</div>
                            <div className="expanded-data">
                              <div className="head">Invoice iD:</div>
                              <div className="details">{invoice?.id}</div>
                            </div>
                            <div className="expanded-data">
                              <div className="head">Rent:</div>
                              <div className="details">{invoice?.rent}</div>
                            </div>
                            <div className="expanded-data">
                              <div className="head">Water:</div>
                              <div className="details">{invoice?.water}</div>
                            </div>
                            <div className="expanded-data">
                              <div className="head">Garbage:</div>
                              <div className="details">{invoice?.garbage}</div>
                            </div>
                            <div className="expanded-data">
                              <div className="head">Service charge:</div>
                              <div className="details">{invoice?.serviceCharge}</div>
                            </div>
                            <div className="expanded-data">
                              <div className="head">Arrears:</div>
                              <div className="details">{invoice?.arrears}</div>
                            </div>
                            <div className="expanded-data">
                              <div className="head">Unpaid deposit:</div>
                              <div className="details">{invoice?.unpaidDeposit}</div>
                            </div>
                            <div className="expanded-data">
                              <div className="head">Late fee:</div>
                              <div className="details">{invoice?.lateFee}</div>
                            </div>

                            <div className={`expanded-data final`}>
                              <div className="head">Total Payable Amount:</div>
                              <div className="total">
                                {invoice?.totalPayable}
                              </div>
                            </div>
                            <button onClick={() => handlePayment(invoice?.id)}>
                              Make Payment
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )} */}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          <div className="buttons-container">
            {visibleInvoicesCount < invoices.length && (
              <button
                onClick={showMoreInvoices}
                className="show-more-and-hide-button"
              >
                Show More
              </button>
            )}
            {visibleInvoicesCount > 3 && (
              <button
                onClick={hideAllInvoices}
                className="show-more-and-hide-button"
              >
                Hide All
              </button>
            )}
          </div>

          <PaymentModal
            isOpen={isOpen}
            closeModal={closeModal}
            selectedApartmentId={selectedApartmentId}
            defaultValues={defaultValues} // Set default values here
            fieldsToShow={[
              "rent",
              "arrears",
              "water",
              "serviceCharge",
              "unpaidDeposit",
              "garbage",
            ]} // Specify which fields to show
          />
        </div>
      )}
    </>
  );
};
function transformInvoices(invoices) {
  console.log("received these invoices", invoices);

  return invoices
    .filter((invoice) => invoice?.payment_status !== "fully_paid") // Filter out fully paid invoices
    .map((invoice) => {
      // Calculate the total amount by summing up the individual charges
      const totalAmount = (
        parseFloat(invoice?.rent_invoice || 0) +
        parseFloat(invoice?.water_invoice || 0) +
        parseFloat(invoice?.garbage_charge || 0) +
        parseFloat(invoice?.arrears || 0) +
        parseFloat(invoice?.service_charge || 0) +
        parseFloat(invoice?.unpaid_deposit || 0) +
        parseFloat(invoice?.late_fee || 0) 
      ).toFixed(2); // Ensure it's a number with two decimal places

      // Determine the status
      const status =
        invoice?.payment_status === "fully_paid" ? "Paid" : "Unpaid";

      // Calculate total payable amount
      const totalPayable = totalAmount; // Adjust if you need to add any extra charges

      return {
        id: `INV${(invoice?.invoice_id || "").padStart(3, "0")}`, // Format ID with leading zeros
        house_id: invoice?.house_id,
        house_no: invoice?.house_no,
        status: status,
        dueDate: invoice?.due_date
          ? new Date(invoice?.due_date).toISOString().split("T")[0]
          : "no due date", // Return "no due date" if due_date is null or undefined
        totalAmount: totalAmount,
        rent: invoice?.rent_invoice || "0",
        water: invoice?.water_invoice || "0",
        garbage: invoice?.garbage_charge || "0",
        arrears: invoice?.arrears || "0",
        serviceCharge: invoice?.service_charge || "0",
        unpaidDeposit: invoice?.unpaid_deposit || "0",
        lateFee: invoice?.late_fee || "0",
        isEdited: invoice?.isEdited,
        totalPayable: totalPayable,
      };
    });
}

export default InvoicePendingTable;
